import React, { useEffect, useState } from "react";

import { DescriptionText, DifficultyContainer } from "./difficulty.styles";

import DifficutlyCircles from "../difficulty-circles/difficulty-circles.component";

const Difficulty = ({ difficulty }) => {
	const [fontSize, setFontSize] = useState(16);
	var difficultyContainerRef;

	useEffect(() => {
		const height = difficultyContainerRef.offsetHeight;

		setFontSize(height - height / 5);
	}, [difficultyContainerRef]);

	return (
		<DifficultyContainer
			ref={divElement => {
				difficultyContainerRef = divElement;
			}}
		>
			<DescriptionText fontSize={fontSize}>difficulty: </DescriptionText>
			<DifficutlyCircles difficulty={difficulty} margin={3} circleBorder={2} />
		</DifficultyContainer>
	);
};

export default Difficulty;
